<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>IQAC</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">IQAC</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<!-- ABOUTUS
       ================================================== -->
<section class="aboutus-style-02">
    <div class="container">
        <div class="row align-items-center mt-n1-9">
            <div class="col-lg-12 col-xl-12 mt-1-9">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">IQAC</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary">IQAC Home</h2>
                <p>The IQAC, Arni University, was constituted in the fag end of 2018 as mandated by University Grants
                    Commission and as per National Assessment and Accreditation Council (NAAC) guidelines every Higher
                    Educational Institution (HEI) should establish an Internal Quality Assurance Committee (IQAC). The
                    IQAC is an integral organ of the institution that will foster towards achievement of the broader
                    objectives of the quality sustenance in academia.</p>
                <p>From the month of November, 2021 new Director is leading the IQAC Team. To streamline the functioning
                    of the IQAC a new committee is reconstituted to work in sync with the Director.</p>
                <p>The Core task of IQAC is to install a robust academic mechanism that reflects international content
                    with enduring quality and all learning capabilities.
                </p>

                <h2>Mandate:</h2>
                <ul>
                    <li>- To suggest innovative measures for quality enhancement</li>
                    <li>- To adhere to the accreditation/assessment process by competent agencies</li>
                </ul>
                <h2>Functions IQAC:</h2>
                <ul>
                    <li>- Development and Application of quality benchmarks / parameters for the various academic &
                        Administrative activities of the University
                    </li>
                    <li>- Facilitating the creation of a learner-centric environment conducive to quality education and
                        faculty maturation to adopt the required knowledge and technology for participatory teaching and
                        learning process
                    </li>
                    <li>- Arrangement for feedback response from students, parents and other stakeholders on
                        quality-related institutional</li>
                </ul>
            </div>
        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>
